import React from 'react'
import Layout from '../../../shared/components/organisms/layout/layout'
import Seo from '../../../shared/seo'
import useMediaQuery from '../../../utils/useMediaQuery' 
import ModalViewer from '../../organisms/modal-viewer/modal-viewer'
import { title, description } from './../../../constants/activity-seo'

const PageLayout = ({ hiddenNav, children }) => {
  const isMobile = useMediaQuery()

  return (
    <Layout mobile={isMobile}>
      <Seo title={title} description={description} />
      <ModalViewer />
      <div style={{ display: 'flex', flexDirection: 'column' }}> 
        <div className={isMobile ? "" : "f-mt46"}>{children}</div>
      </div>
    </Layout>
  )
}

export default PageLayout
